import { threeEngine } from 'Domain/Scene/Engine/ThreeEngine';


/*****************************************************************
 * GET REFERENCES MODIFICATIONS
 * ***************************************************************/

export const GetReferencesModifications = async () => {

    return fetch(process.env.REACT_APP_U1_VIEWERSVC_API + '/project/get-matrix', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: threeEngine.getProjectId() })
    })
    .then(response => response.json())
    .then(data => {
        return data;
    })
    .catch((error) => {
        console.error('Modification loader Error:', error);
        throw error;
    });
}


export const GetAllVersions = async () => {

    const url = process.env.REACT_APP_U1_VIEWERSVC_API + '/project/getall-matrix';
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: threeEngine.getProjectId()})
    })
        .then(response => response.json())
        .then(data => {
            return data;
        })
        .catch((error) => {
            console.error('Modification loader Error:', error);
            throw error;
        });
}
